import Start from './Start'

export {
  Start
}


// WEBPACK FOOTER //
// ./src/components/Start/index.js